import { DepartmentRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * departmentOnUpdateData - Function that updates on database an existing department by id  
 * /departments/{id}
 * method PUT  
 * @async-function
 */
const departmentOnUpdateData = async (token: string, model: DepartmentRequestType, id: number) => {
    const response = await api.put(
        `/departments/${id}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default departmentOnUpdateData;